// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2AREv","name":"ConsentHeader_name__bRxER","birthday":"ConsentHeader_birthday__2OJ2x","skeleton":"ConsentHeader_skeleton__25OCy"};